import { useMemo, useLayoutEffect, useEffect } from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import canUseDOM from '../../utils/canUseDOM/c67777c3ad1eb68171c13859212224771d86d89bae09127a82a280a9f9573215.cfe-internal.js';

var useSSRLayoutEffect = function useSSRLayoutEffect() {
  var effectFunc = useMemo(function () {
    return canUseDOM() ? useLayoutEffect : useEffect;
  }, []);
  return effectFunc.apply(void 0, arguments);
};

export { useSSRLayoutEffect as default };
